import { Injectable } from '@angular/core';
import { MessageService } from 'primeng/api';

@Injectable({
  providedIn: 'root',
})
export class ToastMessageService {

  constructor(private messageService:MessageService) { }

  showMessage(key: string, severity: string, summary: string, detail: string, life: number) {
    this.messageService.add({ key: key, severity: severity, summary: summary, detail: detail, life: life });
  }
}
